// @flow

import { OPEN_DIALOG, CLOSE_DIALOG } from '../action/dialog';

export type Action = {
  type: string,
  meta?: any,
  payload?: any,
  error?: any
}

const InitialState = {
  openDialogName: null, // a dialog name from util/dialogs
};

export const uiStateReducer = (state: Object = InitialState, action: Action) => {
  switch (action.type) {
    case OPEN_DIALOG: {
      return { ...state, openDialogName: action.payload };
    }
    case CLOSE_DIALOG: {
      return { ...state, openDialogName: null };
    }
    default:
      return state;
  }
};
